import APIClient from './api/index';
import storeData from './configureStore';
import cogoToast from 'cogo-toast';
import { refreshAccessToken } from './api/users';
import { REFRESH_TOKEN_SUCCESS, LOGOUT_USER_SUCCESS } from './actions/UserActions';

APIClient.interceptors.request.use(function (config) {
  const token = storeData.store.getState()?.user?.tokens?.access_token;
  config.headers.Authorization = token && !config.skipAuth ? `Bearer ${token}` : '';
  return config;
});

let retryAuthAttempt = 0;
const MAX_401_RETRY = 3;

APIClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger.
    if (error?.response?.status === 401 && retryAuthAttempt < MAX_401_RETRY) {
      const refresh_token = storeData.store.getState()?.user?.tokens?.refresh_token;

      // If Access Token is timed out, refresh this token.
      if (refresh_token) {
        retryAuthAttempt += 1;
        try {
          const resp = await refreshAccessToken({ refresh: refresh_token });
          if (resp.access) {
            storeData.store.dispatch({ type: REFRESH_TOKEN_SUCCESS, tokens: { refresh_token, access_token: resp.access } });
            let newConfig = { ...error.config };
            newConfig.headers.Authorization = `Bearer ${resp.access}`;
            return APIClient.request(newConfig);
          }
        } catch (error) {
          // Seems there was an error refreshing the access token
          console.error(`Could not fetch new token`, error);
        }
      }

      // Force Logout
      storeData.store.dispatch({ type: LOGOUT_USER_SUCCESS });
      retryAuthAttempt === MAX_401_RETRY - 1 && cogoToast.warn('Your session has expired, please log back in.');
    }

    retryAuthAttempt = 0;
    return Promise.reject(error.response);
  }
);
